import { GraphOptionItemProps } from '../types'
import { FormControlLabel, Switch } from '@mui/material'

export const GraphOptionCheckItem = <T,>({
	option,
	options,
	setOptionValue
}: GraphOptionItemProps<T>) => (
	<FormControlLabel
		labelPlacement="top"
		control={
			<Switch
				size='small'
				checked={
					(options.find((opt) => opt.id === option.id)?.value ??
						option.default) === 'true'
				}
				onChange={(event) =>
					setOptionValue(
						option.id,
						event.target.checked ? 'true' : 'false'
					)
				}
				id={`check-${option.id}`}
			/>
		}
		label={option.label}
	/>
)